
<template>
    
        <mars-view class="loading"><mars-view :style="{
            width,
            height
        }" class="icon"><mars-view :style="{
                width,
                height
            }" class="border"></mars-view><c-icon :style="{
                color: iconColor
            }" :font-size="iconSize" name="baidu-logo"></c-icon></mars-view><mars-view :style="{
            color: textColor
        }" class="text c-font-normal c-gap-top">
        {{ text }}
    </mars-view></mars-view>
    
</template>

<script>
import Icon from "../Icon/Icon.vue";
export default {
  components: {
    'c-icon': Icon
  },
  props: {
    /**
     * 文案
     */
    text: {
      type: String,
      default: '加载中...'
    },

    /**
     * 文字颜色
     */
    textColor: {
      type: String,
      default: '#999'
    },

    /**
     * 宽度
     */
    width: {
      type: String,
      default: '54px'
    },

    /**
     * 高度
     */
    height: {
      type: String,
      default: '54px'
    },

    /**
     * 图标宽度
     */
    iconSize: {
      type: String,
      default: '30px'
    },

    /**
     * 图标颜色
     */
    iconColor: {
      type: String,
      default: '#f3f3f3'
    }
  }
};
</script>

<style scoped>
.loading {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-line-pack: center;
      align-content: center;
}
.icon {
  position: relative;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.border {
  position: absolute;
  display: block;
  margin: auto;
  border: 2px solid #f3f3f3;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-top-color: #ddd;
  border-radius: 50%;
  -webkit-animation: anim-rotation 1s ease 0s infinite normal;
  animation: anim-rotation 1s ease 0s infinite normal;
}
@keyframes anim-rotation {
  from {
    -webkit-transform: rotate(1deg);
    transform: rotate(1deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes anim-rotation {
  from {
    -webkit-transform: rotate(1deg);
    transform: rotate(1deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.text {
  text-align: center;
}

</style>
